const apartmentTypeMap = {
  KT: "Kerrostalo",
  OT: "Omakotitalo",
  RT: "Rivitalo",
  PT: "Paritalo",
  ET: "Erillistalo",
  MO: "Mökki/huvila",
  LH: "Lomahuoneisto",
  UL: "Loma-asunto ulkomailla",
  LO: "Lomaosake",
  OKTT: "Omakotitalotontti",
  VT: "Vapaa-ajan tontti",
  RTT: "Rivitalotontti",
  TO: "Tontti",
  AP: "Autopaikka",
  AT: "Autotalli",
  MAT: "Maatila",
  MET: "Metsätila",
  TOT: "Toimistotila",
  LT: "Liiketila",
  VART: "Varastotila",
  TUT: "Tuotantotila",
  PUUT: "Puutalo-osake",
  LUHT: "Luhtitalo",
};

export const apartmentTypeToLabel = (type) =>
  apartmentTypeMap[type] ? apartmentTypeMap[type] : "";
